import { IUser } from "authentication/domain/IUser";
import { authServices } from "authentication/services/auth.service";
import Modal from "components/Modal/Modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "react-oidc-context";
import config from "config/Config";

interface IProps {
  setClickOutsideActive: Function;
  isOpen: boolean;
  setIsOpen: Function;
  user: IUser | null;
  currentUser: IUser;
  useConfirmation?: boolean;
}

const UpdateUserPasswordModal = ({
  setClickOutsideActive,
  isOpen,
  setIsOpen,
  user,
  currentUser,
  useConfirmation = false,
}: IProps) => {
  const auth = useAuth();
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const closeDialog = () => {
    setIsOpen(false);
    setClickOutsideActive(true);
  };

  const changePassword = async () => {
    try {
      if (user) {
        if (useConfirmation && password !== passwordConfirmation) {
          toast.error("Šifra i njena potvrda nisu iste!");
        } else {
          if (useConfirmation) {
            await authServices.updateCurrentUserPassword(password, passwordConfirmation);
          } else {
            await authServices.updatePassword(user.username, password);
          }

          setPassword("");
          closeDialog();
          toast.success("Šifra je uspešno promenjena.");
          if (user.username === currentUser.username) {
            authServices.logout();
            auth.signoutRedirect({ post_logout_redirect_uri: config.HOME_URL });
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeDialog}
      onClick={changePassword}
      title="Menjaj šifru"
    >
      <p className="info-msg">
        Ovde menjate šifru korisnika <b>{user?.username}</b>:
      </p>

      <div className="g-modal-input">
        <div>
          <label>Nova šifra:</label>
          <input
            className="inputField"
            type="password"
            name="projectName"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {/* {errors.projectName && (
          <div className="g-modal-validation">Obavezno polje!</div>
        )} */}
      </div>
      {useConfirmation && (
        <>
          <br />
          <div className="g-modal-input">
            <div>
              <label>Potvrda šifre:</label>
              <input
                type="password"
                className="inputField"
                onChange={(e) => setPasswordConfirmation(e.target.value)}
              />
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default UpdateUserPasswordModal;
